import { Component, OnInit,Input } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { SeoService } from './../../services/seo.service'
@Component({
  selector: 'app-sharing-buttons',
  templateUrl: './sharing-buttons.component.html',
  styleUrls: ['./sharing-buttons.component.scss']
})
export class SharingButtonsComponent implements OnInit {

  @Input() title:string = '';
  @Input() description:string;
  @Input() image:string;
  url = window.location.href;


  constructor(private seoService:SeoService,) {

  }

  ngOnInit() {
    this.description = this.description.replace(/<\/?[^>]+(>|$)/g, '')

    if (this.title != '') {
      // this.seoService.setTagsPage({
      //   title:`Cptur | ${this.title}`,
      //   description:this.description,
      //   image:this.image
      // });
    }

  }

}
